import useAsyncData from 'src/utils/useAsyncData';
import { getAllowedBanksAPI } from 'src/serverApi/applications';

const useApplicationAllowedBanks = () => {
  const [
    fetchAllowedBanks,
    wasAllowedBanksFetched,
    isAllowedBanksLoading,
    allowedBanks,
    allowedBanksError,
  ] = useAsyncData(getAllowedBanksAPI);

  return {
    fetchAllowedBanks,
    wasAllowedBanksFetched,
    isAllowedBanksLoading,
    allowedBanks,
    allowedBanksError,
  };
};

export default useApplicationAllowedBanks;
